/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const TimeseriesPoint = zod
	.object({
		compliant: zod.number().describe('Cases that passed compliance'),
		total_cases: zod.number().describe('Total moderation cases'),
		ts: zod.iso.datetime({ offset: true }).describe('Bucket timestamp'),
		violations: zod.number().describe('Cases flagged as violations')
	})
	.describe('Moderation timeseries data point');

export type TimeseriesPoint = zod.input<typeof TimeseriesPoint>;
export type TimeseriesPointOutput = zod.output<typeof TimeseriesPoint>;
